<div class="c-progressbar__wrapper">
  <div class="c-progressbar">
    <div class="c-progressbar__progress" [style.width.%]="getProgressPercent"></div>
  </div>
  <p class="c-progressbar__hours">
    <span [class.failure]="timeOutBounds">{{convertMinutesToHours(phaseProgressTime)}}</span>/{{convertMinutesToHours(allPhaseTime)}}{{'h' | translate}}
  </p>
</div>
